module.exports = __webpack_public_path__ + "img/avatar05.347db5c7.jpg";